export default __webpack_public_path__ + "static/media/block_info.03da5599.png";